import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlus, faEllipsis, faDownload, faCircleXmark, faPencil } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState, useImperativeHandle, forwardRef, } from "react";
import Slider from "react-slick";
import Docmnt from "../../../../../assets/images/google-docs.png";
import { Modal, Button, Alert, Table, Tabs, Tab } from "react-bootstrap";
import { SAVEATTACHMENTS, DELETEATTACHMENTS, DOWNLOADFILES, CONVERTBLOB, HISTORYSAVEATTACHMENTS, } from "../../../../../Utils/conts.js";
import Form from "react-bootstrap/Form";
import Galpic from "../../../../../assets/images/photo.png";
import Bin from "../../../../../assets/images/bin.png";
import Radown from "../../../../../assets/images/radown.png";
import Trash from "../../../../../assets/images/trash.png";
import Uploadn from "../../../../../assets/images/upload-n.png";
import Uploadw from "../../../../../assets/images/upload-w.png";
import Shipupload from "../../../../../assets/images/ship_upload.png";

import Arcv from "../../../../../assets/images/archive.svg";
import Export from "../../../../../assets/images/export.svg";

import { withoutRFSToken, withRFSToken } from "../../../../../Services/axios.js";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import { Link } from "@mui/material";
import axios from "axios";
// const ImageUpload = ({ attachable_type, attachable_id, attachments }) => { // OLD
const ImageUpload = forwardRef(
  ({ attachable_type, attachable_id, attachments, onDeleteSuccess, group_id, history, attachment_no }, ref) => {
    const [files, setFiles] = useState([]);
    const [ufiles, setUfiles] = useState([]);
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [selectedDelFile, setSelectedDelFile] = useState({
      index: null,
      id: null,
    });
    // console.log('attachable_id', attachable_id);

    const [activeTab, setActiveTab] = useState('All');

    const [showModalUpload, setShowModalUpload] = useState(false);
    const [uploadTarget, setUploadTarget] = useState('');
    const fileInputRefs = useRef(null);
    const fileInputRefc = useRef({});
    const [formData, setFormData] = useState({});
    const [base64Files, setBase64Files] = useState([]);
    const [ubase64Files, setUbase64Files] = useState([]);
    const [rfiles, setRfiles] = useState([]);
    const [sendData, setSendData] = useState({});

    const handleTabChange = async (tab) => {
      setActiveTab(tab);
      setSelectedRows([]);
    }

    useEffect(() => {
      if (attachments) {
        setFiles(attachments);
      }
    }, [attachments]);
    // console.log('files:::', files);
    const handleDrop = (e) => {
      e.preventDefault();
      const droppedFiles = Array.from(e.dataTransfer.files);
      setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    };
    const handleDragOver = (e) => {
      e.preventDefault();
    };
    const handleBrowseFiles = (e, pos, nam) => {
      e.preventDefault();
      console.log('fileInputRef.current', nam);
      if (pos == 'G') {
        if (nam) {
          if (fileInputRefc.current[nam]) {
            fileInputRefc.current[nam].click();
          }
        } else { fileInputRefs.current.click(); }
      } else { fileInputRef.current.click(); }
      // if (nam) {
      //   if (fileInputRefs.current[nam]) {
      //     fileInputRefs.current[nam].click();
      //   }
      // } else { fileInputRef.current.click(); }
    };
    useImperativeHandle(ref, () => ({
      handleBrowseFiles,
    }));

    const [isMulti, setIsMulti] = useState(false);
    const [multiData, setMultiData] = useState({ upload_type: 'S' });
    const multipleUpload = () => {
      setIsMulti(true);
      setShowConfirmation(true);
    };
    const multiDatachange = (e) => {
      const { name, value } = e.target;
      setMultiData(prevFormData => ({
        ...prevFormData,
        [name]: value
      }));
    };
    const handleMultiConfirm = (e) => {
      if (e) {
        e.preventDefault();
      }
      fileInputRef.current.click();
      setShowConfirmation(false);
      setIsMulti(false);
    };

    const galleryFileChange = (e, pos, chk) => {
      // if (formData.id) {
      const selectedFiles = Array.from(e.target.files);
      const filesWithBase64 = [];
      let filesProcessed = 0;

      // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
      const existingBase64Files = formData?.ubase64Files || [];

      selectedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = async () => {
          if (file.size > 26214400) {
            toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
            return;
          }
          filesWithBase64.push({ file, base64: reader.result, file_name: file.name, type: file.type });
          filesProcessed += 1;
          if (filesProcessed === selectedFiles.length) {

            // } else {
            const newFiles = filesWithBase64.map((obj) => obj.file);
            console.log("🚀 ~ reader.onloadend= ~ newFiles:", filesWithBase64);
            let newBase64Files;
            if (pos === 'C') {
              newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
            } else {
              newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
            }
            console.log('newBase64Files', newBase64Files);

            // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
            const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

            // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
            setUfiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
            setUbase64Files(mergedBase64Files);
            if (pos == 'R') {
              setRfiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, type: obj.type }))]);
              setSendData((prevFormData) => {
                // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                return newFormData;
              });
            }

            // }
          }
        };
        reader.readAsDataURL(file);
      });
      // } else {
      //     toast.error('Please add Shipper first')
      // }

    };

    const handleFileChange = (e) => {
      const selectedFiles = Array.from(e.target.files);
      const filesWithBase64 = [];
      const allBase64 = [];
      selectedFiles.forEach((file) => {
        const reader = new FileReader();
        // console.log("🚀 ~ selectedFiles.forEach ~ reader:", reader)
        reader.onloadend = async () => {
          if (file.size > 26214400) {
            toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
            return;
          }
          filesWithBase64.push({ file, base64: reader.result });
          // allBase64.push(reader.result);
          allBase64.push({ base64: reader.result, file_name: file.name }); // for file name
          if (filesWithBase64.length === selectedFiles.length) {
            let allData;
            let res;
            let postUrl;
            if (group_id) {
              allData = {
                group_id: group_id,
                attachable_type: attachable_type,
                base64Files: allBase64,
              };
              res = await withRFSToken.post(HISTORYSAVEATTACHMENTS, allData);
            } else if (attachable_type == 'booking_schedule') {
              if (multiData.upload_type == 'S') {
                allData = {
                  attachable_id: attachable_id.bookingtruck_date_id,
                  attachable_type: 'booking_schedule_date',
                  files: allBase64,
                };
              } else {
                allData = {
                  attachable_id: attachable_id.bookingtruck_id,
                  attachable_type: 'booking_schedule',
                  files: allBase64,
                };
              }

              // multipleUpload(allData);
              res = await withRFSToken.post(SAVEATTACHMENTS, allData);
            } else if (attachable_type == 'exp_shipment_record' || attachable_type == 'imp_shipment_record') {
              if (attachable_type == 'exp_shipment_record') {
                allData = {
                  shipmen_id: attachable_id,
                  shipmen_type: "export",
                  attachments: allBase64,
                };
                postUrl = 'shipment/upload-doc';
              } else if (attachable_type == 'imp_shipment_record') {
                allData = {
                  shipmen_id: attachable_id,
                  shipmen_type: "import",
                  attachments: allBase64,
                };
                postUrl = 'shipment/upload-doc';
              } else if (attachable_type == 'rfs_order') {
                allData = {
                  attachable_id: attachable_id,
                  attachable_type: "rfs_order",
                  files: allBase64,
                };
                postUrl = 'attachment-save';
              }
              // multipleUpload(allData);
              res = await withRFSToken.post(postUrl, allData);

            } else {
              allData = {
                attachable_id: attachable_id,
                attachable_type: attachable_type,
                files: allBase64,
              };
              res = await withRFSToken.post(SAVEATTACHMENTS, allData);
            }
            // const 
            // .then(function (res) {
            if (res.data.response_code == 200) {
              const innerData = res.data.response_data;
              if (group_id) {
                setFiles((prevFiles) => [...prevFiles, ...innerData]);
                const storageData = JSON.parse(localStorage.getItem('MHDetails'));
                if (storageData && storageData.Form) {
                  storageData.Form.attachments = [...storageData.Form.attachments, ...innerData];
                  localStorage.setItem('MHDetails', JSON.stringify(storageData));
                }
              } else if (history) {
                setFiles((prevFiles) => [...prevFiles, ...innerData]);
                const storageData = JSON.parse(localStorage.getItem('MHistory'));
                if (storageData && storageData.ULD) {
                  storageData.ULD.attachments = [...storageData.ULD.attachments, ...innerData];
                  localStorage.setItem('MHistory', JSON.stringify(storageData));
                }
              } else {
                // setFiles((prevFiles) => [...prevFiles, ...innerData]);
                onDeleteSuccess();
              }

              toast.success("Uploaded Successfully");
            } else {
              toast.error(res.data.response_msg);
            }

            // });
          }
        };
        reader.readAsDataURL(file);
      });
    };

    const handleFileClick = (file) => {
      setSelectedFile(file);
      setImgShow(true);
    };
    const [galleryViewOpen, setGalleryViewOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isTopDel, setIsTopDel] = useState(false);

    const handleDeleteFile = async (index, id, type) => {
      let allData;
      if (isTopDel) {
        if (attachable_type == "rfs_order") {
          const attachment_ids = selectedRows
            .filter(item => Number(item.remarks_attachment) !== 1)
            .map(item => ({
              attachment_id: item.attachment_id,
              attachment_type: "O"
            }));
          allData = {attachment_ids:attachment_ids};
        } else {
          const ids = selectedRows.filter(fl => Number(fl.remarks_attachment) !== 1).map(data => data.file_id)
          allData = { shipment_id: attachable_id, shipment_type: attachable_type == 'exp_shipment_record' ? 'export' : 'import', file_ids: ids };
        }
      } else {
        if (attachable_type == "rfs_order") {
          allData =
          {
            attachment_id: selectedDelFile.id,
            attachment_type: selectedDelFile.type,
          };
        } else {
          allData = [
            {
              attachment_id: selectedDelFile.id,
              attachment_type: selectedDelFile.type,
            },
          ];
          apiUrl = 'shipment/remove-all-attachments';
        }

      }
      let apiUrl;
      if (attachable_type == "rfs_order") {
        apiUrl = 'attachment-delete';
      } else {
        apiUrl = 'shipment/remove-all-attachments';
      }
      const res = await withRFSToken.post(apiUrl, allData)
        .then(function (res) {
          if (res.data.response_code == 200) {
            toast.success("Deleted Successfully");
            if (group_id) {
              setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
              });
              const storageData = JSON.parse(localStorage.getItem('MHDetails'));
              if (storageData && storageData.Form && storageData.Form.attachments) {
                storageData.Form.attachments.splice(index, 1);
                localStorage.setItem('MHDetails', JSON.stringify(storageData));
              }
            } else if (history) {
              setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
              });
              const storageData = JSON.parse(localStorage.getItem('MHistory'));
              if (storageData && storageData.ULD && storageData.ULD.attachments) {
                storageData.ULD.attachments.splice(index, 1);
                localStorage.setItem('MHistory', JSON.stringify(storageData));
              }
            } else {
              onDeleteSuccess();
            }
            // setFiles(prevFiles => {
            //     if (selectedRows.length > 0) {
            //         const selectedIds = new Set(selectedRows.map(row => row.id));
            //         return prevFiles.filter(file => !selectedIds.has(file.id));
            //     } else {
            //         const newFiles = [...prevFiles];
            //         newFiles.splice(index, 1);
            //         return newFiles;
            //     }
            // });
            // if (selectedRows.length > 0) {
            setSelectedRows([]);
            setIsTopDel(false);
            // }
          } else {
            toast.error(res.data.response_msg);
          }
        });
    };

    const handleUDeleteFile = (index, pos) => {
      setUfiles((prevFiles) => {
        const newFiles = [...prevFiles];
        newFiles.splice(index, 1);
        return newFiles;
      });
      if (pos == 'R') {
        setRfiles((prevFiles) => {
          const newFiles = [...prevFiles];
          newFiles.splice(index, 1);
          return newFiles;
        });
      }
      // base64Files.splice(index, 1);
      setUbase64Files((prevBase64Files) => {
        const newBase64Files = [...prevBase64Files];
        newBase64Files.splice(index, 1);
        if (pos == 'R') {

          setSendData((prevFormData) => {
            // const newFiles = [...prevFormData.files];
            const newFiles = Array.isArray(prevFormData.files) ? [...prevFormData.files] : [];
            newFiles.splice(index, 1);
            return { ...prevFormData, files: newFiles };
          });
        }
        // Update local storage


        return newBase64Files;
      });
    };
    const handleClose = () => {
      setImgShow(false);
      setSelectedFile("");
    };
    var settings = {
      dots: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
    };
    const handleDeleteImage = (index, id, type) => {
      setSelectedDelFile({ index, id, type });
      setShowConfirmation(true);
    };
    const handleDeleteImageTop = () => {
      if (selectedRows.length > 0) {
        setShowConfirmation(true);
        setIsTopDel(true);
      } else {
        toast.error("Please select at least one image");
      }
    };
    const closeConfirm = () => {
      setShowConfirmation(false);
      setSelectedDelFile({ index: null, id: null });
      setIsTopDel(false);
      setIsMulti(false);
    };
    const handleConfirmation = (confirm) => {
      if (confirm) {
        handleDeleteFile(
          selectedDelFile.index,
          selectedDelFile.id,
          selectedDelFile.type
        );
        setShowConfirmation(false);
      } else {
        closeConfirm();
      }
    };

    function extractPath(url) {
      try {
        let urlObject = new URL(url);
        let path = urlObject.pathname.substring(1);
        return path;
      } catch (error) {
        console.error("Invalid URL:", error);
        return null;
      }
    }
    const handleDownload = async (imageUrl, imageName) => {
      const path = extractPath(imageUrl);
      const res = await withRFSToken
        .post("get-file-blob", {
          file_path: path,
        })
        .then((response) => {
          const pdfData = atob(response.data.response_data.file_base64);
          const byteNumbers = new Array(pdfData.length);
          for (let i = 0; i < pdfData.length; i++) {
            byteNumbers[i] = pdfData.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: response.data.response_data.mime_type,
          });
          saveAs(blob, imageName);
        })
        .catch((error) => {
          console.error("Error during the file download:", error);
          alert("Could not download the file");
        });
    };

    const showGalleryView = () => {
      setGalleryViewOpen(true);
    };
    const galleryViewclose = () => {
      setGalleryViewOpen(false);
      setSelectedRows([]);
    };
    const handleCheckboxChange = (file, isChecked) => {
      if (isChecked) {
        // setSelectedRows([...selectedRows, file]);
        setSelectedRows((prevSelectedRows) => [
          ...prevSelectedRows,
          { attachment_id: file.sn, attachment_type: file.attachment_type, path: file.file_path, file_id: file.file_id, remarks_attachment: file.remarks_attachment },
        ]);
      } else {
        setSelectedRows(
          selectedRows.filter((row) => row.attachment_id !== file.sn)
        );
      }
    };
    const multipleDownload = async () => {
      console.log('selectedRows', selectedRows);
      if (selectedRows.length > 0) {
        const payload = selectedRows.map(data => data.path)
        console.log("🚀 ~ multipleDownload ~ payload:", payload)
        const res = await withRFSToken.post('shipment/download-all-attachments', { attachments: payload }) // { uld_number: attachable_type == 'booking_schedule_date' || attachable_type == 'booking_schedule' || attachable_type == 'missing_uld' ? attachment_no : attachable_id, attachments: selectedRows, }
          .then(function (res) {
            if (res.data.response_code == 200) {
              const downloadUrl = res.data.response_data.file_url;
              const a = document.createElement("a");
              a.href = downloadUrl;
              a.download = "download.zip"; // You can set a default filename here
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              toast.success("Downloaded Successfully");
            } else {
              toast.error(res.data.response_msg);
            }
          });
      } else { toast.error('Please select at least one attachment') }

    };

    const imageModalUpload = () => {
      setShowModalUpload(true);
    }
    const imageUpload = async () => {
      // setGridSelect(prevGridSelect =>
      //     prevGridSelect.map(item => {
      //         if (item.uid === selectedRowId) {
      //             return { ...item, files: files, base64Files: base64Files };
      //         }
      //         return item;
      //     })
      // );
      // setShowModalUpload(false);
      let payload = {};
      let urlLink = "";
      if (attachable_type == "rfs_order") {
        payload = {
          attachable_id: attachable_id,
          attachable_type: "rfs_order",
          files: ubase64Files
        }
        urlLink = "attachment-save";
      } else {
        payload = {
          shipmen_id: attachable_id,
          shipmen_type: attachable_type == "exp_shipment_record" ? "export" : "import",
          attachments: ubase64Files
        }
        urlLink = 'shipment/upload-doc';
      }
      try {
        const res = await withRFSToken.post(urlLink, payload);
        if (res.data.response_code === 200) {
          toast.success(res.data.response_msg);
          setFormData(res.data.response_data);
          setShowModalUpload(false);
          setUfiles([])
          setUploadTarget('');
          onDeleteSuccess();
        } else {
          toast.error(res.data.response_msg);
        }

      } catch (error) {
        console.error('Error saving shipment record:', error);
      }

    };

    const closeModalUpload = () => {
      setShowModalUpload(false);
      setUfiles([])
      setUploadTarget('');
    }

    const [typeModal, setTypeModal] = useState(false);
    const [modalSection, setModalSection] = useState('');
    const [modalData, setModalData] = useState({});
    const [typeData, setTypeData] = useState('');

    const handleOpenModal = (pos, data) => {
      setModalData(data);
      setTypeModal(true);
      setModalSection(pos);
      setTypeData(data.category[0])
    }
    const modalChange = (e) => {
      setTypeData(e.target.value);
    }
    const modalUpdate = async () => {
      if (modalSection === 'S') {
        if (typeData !== null) {
          let payload;
          let apiUrl;
          if (attachable_type == "rfs_order") {
            payload = {
              attachment_id: modalData.id,
              attachment_type: 'O',
              category: [typeData]
            }
            apiUrl='update-attachment-category';
          }else{
            payload = {
              shipmen_id: attachable_id,
              shipmen_type: attachable_type == 'exp_shipment_record' ? 'export' : 'import',
              action_type: 'update',
              file_id: modalData.file_id,
              category: [typeData]
            }
            apiUrl='shipment/update-doc';
          }
          try {
            const res = await withRFSToken.post(apiUrl, payload);
            if (res.data.response_code === 200) {
              setFormData(res.data.response_data);
              toast.success(res.data.response_msg)
              setTypeModal(false);
              onDeleteSuccess()
            } else {
              toast.error(res.data.response_msg)
            }
          } catch (error) {
            console.error('Error saving shipment record:', error);
          }
        } else {
          toast.error('Please change the type first')
        }
      } else {
        let payload;
        let apiurl;
        if (attachable_type == "rfs_order") {
           payload =
          {
            attachment_id:  modalData.id,
            attachment_type: 'O',
          };
          apiurl = 'attachment-delete';
        }else{
          payload = {
            shipmen_id: attachable_id,
            shipmen_type: attachable_type == 'exp_shipment_record' ? 'export' : 'import',
            action_type: 'delete',
            file_id: modalData.file_id
          };
          apiurl='shipment/update-doc'
        }
        
        // console.log(payload);
        try {
          const res = await withRFSToken.post(apiurl, payload);
          if (res.data.response_code === 200) {
            setFormData(res.data.response_data);
            toast.success(res.data.response_msg)
            setTypeModal(false);
            onDeleteSuccess()
          } else {
            toast.error(res.data.response_msg)
          }
        } catch (error) {
          console.error('Error saving shipment record:', error);
        }
      }

    }

    return (
      <>
        <div className={attachable_type === 'missing_uld' ? '' : 'my-3'}>
          <div className="d-flex justify-content-between align-items-center">
            {attachable_type === 'missing_uld' ?
              <h4 className="mb-0">Recovery Case - Attachments ({files.length || 0})</h4>
              :
              <h3 className="mb-0">Attachments ({files.length || 0})</h3>
            }
            <div className="d-flex rightdrop">
              <Dropdown>
                <Dropdown.Toggle variant="link" id="dropdown-basic">
                  <FontAwesomeIcon icon={faEllipsis} />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1" onClick={showGalleryView}>
                    Open gallery view
                  </Dropdown.Item>{" "}
                  {/*onClick={showGalleryView}*/}
                  <Dropdown.Item href="#/action-2">Download all</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <div onDrop={handleDrop} onDragOver={handleDragOver}>
                <button className="raplas" onClick={attachable_type == 'booking_schedule' ? multipleUpload : handleBrowseFiles}>
                  <FontAwesomeIcon icon={faPlus} />
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  multiple
                />
              </div>
            </div>
          </div>

          <div className="raslider">
            {attachable_type === 'missing_uld' ?
              <>
                <Table className='recovery_table '>
                  <thead>
                    <tr>
                      {/* <th></th>
                        <th></th> */}
                      <th></th>
                      <th>Name</th>
                      <th>Size</th>
                      <th>Date added</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {files.map((file, index) => {
                      const fileName = file.file_name;
                      const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                      const extension = fileName?.split(".").pop();

                      return (
                        <tr key={`gv${index}`}>
                          {/* <td>
                              <Form.Check // prettier-ignore
                                type="checkbox"
                                id="checkbox"
                                checked={selectedRows.some(
                                  (row) => row.attachment_id === file.id
                                )}
                                onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                              />
                            </td>
                            <td className="delimg">
                              <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                            </td> */}
                          <td className="delimg">
                            <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                          </td>
                          <td>
                            {["jpeg", "jpg", "png", "webp"].includes(file.file_path.split(".")[file.file_path.split(".").length - 1]
                            ) ? (
                              <>
                                <img
                                  src={file.file_path}
                                  alt="Preview"
                                  style={{
                                    maxWidth: "22px",
                                    maxHeight: "22px",
                                    marginRight: "5px",
                                  }}
                                  // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                  onClick={() => handleFileClick(file.file_path)}
                                />
                                <span>
                                  {/*file.file_name*/}
                                  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                </span>
                              </>
                            ) : (
                              <>
                                <span className="d-flex rafilename">
                                  <img src={Docmnt} className="fileimg" />
                                  <span>{file.file_name}</span>
                                </span>
                              </>
                            )}
                            {/* <img src={Galpic} className='fileimg' /> {file.file_name} */}
                          </td>
                          {/* <td>{file.file_type}</td> */}
                          <td>{file.file_size}</td>
                          <td>{file.upload_time}</td>
                          <td className="delimg">
                            {/* {file.is_comment !== 1 && file.is_editable === 1 && ( */}
                            <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                            {/* )} */}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </>
              :
              <>
                <div className="slider-container">
                  {files.length > 2 ? (
                    <>
                      <Slider {...settings}>
                        {files.map((file, index) => {
                          // console.log("🚀 ~ {files.map ~ file:", file)
                          const fileName = file.file_name;
                          const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                          const extension = fileName?.split(".").pop();
                          return (
                            <>
                              <div key={`sl_${index}`} className="slideimg">
                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                ) ? (
                                  <>
                                    <div>
                                      <img
                                        src={file.file_path}
                                        alt="Preview"
                                        style={{
                                          maxWidth: "30px",
                                          maxHeight: "30px",
                                          marginRight: "10px",
                                        }}
                                        // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                        onClick={() =>
                                          handleFileClick(file.file_path)
                                        }
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <span className="d-flex rafilename">
                                      <img src={Docmnt} className="fileimg" />
                                    </span>
                                  </>
                                )}
                                <span className="rafilename">
                                  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                </span>
                                <div>
                                  <Link to="/" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                    <FontAwesomeIcon icon={faDownload} />
                                  </Link>
                                  {file.is_comment !== 1 &&
                                    file.is_editable === 1 && (
                                      <button
                                        className="slide_dltbtn mmmm"
                                        type="button"
                                        onClick={() => handleDeleteImage(index, file.id, file.attachment_type)}
                                      >
                                        <FontAwesomeIcon icon={faXmark} color="#656565" />
                                      </button>
                                    )}
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </Slider>
                    </>
                  ) : (
                    <>
                      <div className="nonslide">
                        {files.map((file, index) => {
                          const fileName = file?.file_name;
                          // console.log("🚀 ~ {files.map ~ file:", file)
                          const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                          const extension = fileName?.split(".").pop();
                          return (
                            <>
                              <div key={`ns_${index}`} className="slideimg">
                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                ) ? (
                                  <>
                                    <img
                                      src={file.file_path}
                                      alt="Preview"
                                      style={{
                                        maxWidth: "30px",
                                        maxHeight: "30px",
                                        marginRight: "10px",
                                      }}
                                      // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                      onClick={() =>
                                        handleFileClick(file.file_path)
                                      }
                                    />
                                  </>
                                ) : (
                                  <>
                                    <span className="d-flex rafilename">
                                      <img src={Docmnt} className="fileimg" />
                                    </span>
                                  </>
                                )}
                                <span className="rafilename">
                                  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                </span>
                                <Link to="/" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                  <FontAwesomeIcon icon={faDownload} />
                                </Link>

                                {/* {1 === 1 && ( */}
                                {file.is_comment !== 1 &&
                                  file.is_editable === 1 && (
                                    <button
                                      className="slide_dltbtn"
                                      type="button"
                                      onClick={() =>
                                        handleDeleteImage(index, file.id, file.attachment_type)
                                      }
                                    >
                                      <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                  )}
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </>}
            <Modal show={imgShow} onHide={handleClose} centered className="imgmodal">
              <Modal.Header closeButton onClick={handleClose}></Modal.Header>
              <Modal.Body>
                {/* {console.log(selectedFile)} */}
                <img src={selectedFile} className="img-fluid" alt="Selected" />
              </Modal.Body>
            </Modal>
            <Modal show={showConfirmation} onHide={closeConfirm} className="addfrom change_type" centered>
              <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
              <Modal.Body>
                {isMulti ?
                  <>
                    <h3>Add Attachment - Recurring Bookingtruck</h3>
                    <p>Do you want to add this attachment only to this booking truck or to all future recurring booking trucks?</p>
                    <div className="frequnt_modal">
                      <Form.Check
                        inline
                        label={`Add to Single Bookingtruck (${attachment_no} - ${attachable_id.date})`}
                        name="upload_type"
                        type='radio'
                        id='S'
                        value="S"
                        checked={multiData.upload_type == 'S'}
                        onChange={multiDatachange}
                      />
                      <Form.Check
                        inline
                        label={`Add to All Future Bookingtrucks (${attachment_no})`}
                        name="upload_type"
                        type='radio'
                        id='M'
                        value="M"
                        checked={multiData.upload_type == 'M'}
                        onChange={multiDatachange}
                      />
                    </div>
                  </>
                  :
                  <>
                    <h3>The Attachment will be destroyed. </h3>
                    <p>Are you sure you want to continue?</p>
                  </>}
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex w-50 mx-auto are_bottom">
                  {isMulti ?
                    <><Button variant="primary" onClick={handleMultiConfirm}> Upload</Button></>
                    :
                    <>
                      <Button variant="secondary" onClick={() => handleConfirmation(false)}> No</Button>
                      <Button variant="primary" onClick={() => handleConfirmation(true)}> Yes </Button>
                    </>
                  }
                </div>
              </Modal.Footer>
            </Modal>
            <Modal show={galleryViewOpen} onHide={galleryViewclose} className="addfrom change_type" centered size="xl">
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <div className="d-flex justify-content-between">
                  <div className="attchment">
                    <h3>
                      {attachable_type === 'acceptance' ? 'Shipment Attachments - ' : attachable_type === 'missing_uld' ? 'Recovery Case - ' : ''}{attachment_no ? attachment_no : (group_id ? '' : attachable_id)}
                      <span>
                        Attachments
                        <span className="rabadge badge bg-primary">
                          {attachments?.length}
                        </span>
                      </span>
                    </h3>
                  </div>

                  <div className="gallery_download">
                    <button onClick={handleDeleteImageTop}>
                      <img title="" src={Trash} /> <span>Delete</span>
                    </button>
                    <button onClick={multipleDownload}>
                      <img src={Export} /> <span>Download</span>
                    </button>
                  </div>
                </div>
                {console.log('files', files)}
                <div className="row my-3">
                  {['exp_shipment_record', 'imp_shipment_record', 'rfs_order'].includes(attachable_type) &&
                    <div className="col-md-3">
                      <ul className="shipment_gl flbg p-2 mb-0 gallery_check">
                        {(attachable_type === 'rfs_order'
                            ? ["CMR", "ADR", "AWB", "Manifest", "Loading List", "NCTS"]
                            : ["Invoice", "Packinglist", "Emails", "HAWB", "MAWB", "Manifest", "Customs", "Proposal", "Other"]
                          ).map((name) => (
                          <li key={name}>
                            <span>
                              <Form.Check
                                inline
                                label={name}
                                value={name}
                                // id={name}
                                name="group1"
                                // readOnly
                                // onChange={handleChecklicstChange}
                                checked={files?.some(chk => chk.category && chk.category.includes(name)) || false}
                              />
                            </span>
                            <span>
                              {/* <img src={Uploadn} onClick={(e) => handleBrowseFiles(e, name)} /> */}
                              <img src={Uploadn} onClick={() => { setUploadTarget(name); setShowModalUpload(true); }} />
                              {/* <input
                                    type="file"
                                    ref={(el) => (fileInputRefs.current[name] = el)}
                                    style={{ display: "none" }}
                                    name={name}
                                    onChange={(e) => galleryFileChange(e, "C", name)}
                                    multiple
                                /> */}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  }
                  {['exp_shipment_record', 'imp_shipment_record', 'rfs_order'].includes(attachable_type) ?
                    <div className="col-md-9">
                      <div className="flbg gl_tab gallery_upload">
                        <div className="all_file mb-3">
                          <h4>All files</h4>
                          <Button variant="primary" onClick={imageModalUpload}> <img src={Uploadw} /> Upload file</Button>
                        </div>

                        <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="attach_tab">
                          <Tab eventKey="All" title={<span>View All </span>} className='moveto'>
                            <Table className="gallery_view">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  {attachable_type !== "rfs_order" && (
                                    <th>Last Modified</th>
                                  )}
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files.map((file, index) => {
                                  const fileName = file.file_name;
                                  const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                  const extension = fileName?.split(".").pop();

                                  return (
                                    <tr key={`gv${index}`}>
                                      <td>
                                        {/* {console.log('attachment_no', file)} */}
                                        <Form.Check // prettier-ignore
                                          type="checkbox"
                                          id="checkbox"
                                          checked={selectedRows.some(
                                            (row) => row.attachment_id === file.sn
                                          )}
                                          onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                        />
                                      </td>
                                      <td className="delimg">
                                        <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                      </td>
                                      <td>
                                        {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                        ) ? (
                                          <>
                                            <div className="file_attch">
                                              <div className="file_icon">
                                                <img
                                                  src={file.file_path}
                                                  alt="Preview"
                                                  style={{
                                                    maxWidth: "22px",
                                                    maxHeight: "22px",
                                                  }}
                                                  // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                  onClick={() => handleFileClick(file.file_path)}
                                                />
                                              </div>
                                              <div className="file_text">
                                                <p>
                                                  {/*file.file_name*/}
                                                  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                                </p>
                                                <span>{file.file_size}</span> <span>{file.file_ext}</span>
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            {/* <span className="d-flex rafilename">
                                              <img src={Docmnt} className="fileimg" />
                                              <span>{file.file_name}</span>
                                            </span> */}
                                            <div className="file_attch">
                                              <div className="file_icon">
                                                <img src={Docmnt} className="fileimg" onClick={() => { if (extension === 'pdf') { window.open(file.file_path, '_blank'); } }} />
                                              </div>
                                              <div className="file_text">
                                                <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}</p>
                                                <span>{file.file_size}</span> <span>{file.file_ext}</span>
                                              </div>

                                            </div>
                                          </>
                                        )}

                                        {/* <img src={Galpic} className='fileimg' /> {file.file_name} */}
                                      </td>
                                      <td><p>{file.category[0]}</p></td>
                                      <td>
                                        {attachable_type !== "rfs_order" ? (
                                          <>
                                            <p>{file.modified_name}</p>
                                            <span>{file.modified_email}</span>
                                          </>
                                        ) : (
                                          <>
                                            <p>{file.created_by}</p>
                                          </>
                                        )}
                                      </td>
                                      {attachable_type !== "rfs_order" && (
                                        <td>{file.last_modified}</td>
                                      )}

                                      <td className="delimg">
                                        {/* {file.is_comment !== 1 && file.is_editable === 1 && ( */}
                                        <Link to="#" onClick={() => handleOpenModal('S', file)} className="set_link"> <FontAwesomeIcon icon={faPencil} /></Link>
                                        <img src={Bin} onClick={() => handleOpenModal('D', file)} />
                                        {/* )} */}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </Tab>
                          <Tab eventKey="Documents" title={<span>Documents </span>} className='moveto'>
                            <Table className='gallery_view'>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  <th>last modified</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files
                                  ?.filter(({ file_ext, file_type }) => {
                                    const ext = (file_ext || file_type || '').toLowerCase();
                                    return ['doc', 'docx', 'txt'].includes(ext);
                                  })
                                  .map((file, index) => {
                                    const fileName = file.file_name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();
                                    return (
                                      <tr>
                                        <td>
                                          <Form.Check // prettier-ignore
                                            type="checkbox"
                                            id="checkbox"
                                            checked={selectedRows.some(
                                              (row) => row.attachment_id === file.sn
                                            )}
                                            onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                          />
                                        </td>
                                        <td className="delimg">
                                          <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                        </td>
                                        <td>
                                          <span className="d-flex rafilename">
                                            <img src={Docmnt} className="fileimg" />
                                            <span>{file.file_name}</span>
                                          </span>
                                          <span>{file.file_size}</span> <span>{file.file_ext}</span>
                                        </td>
                                        <td><p>{file.category[0]}</p></td>
                                        <td><p>{file.modified_name}</p>
                                          <span>{file.modified_email}</span></td>
                                        <td>{file.last_modified}</td>
                                        <td className="delimg">
                                          {/* {file.is_comment !== 1 && file.is_editable === 1 && ( */}
                                          <Link to="#" onClick={() => handleOpenModal('S', file)} className="set_link"> <FontAwesomeIcon icon={faPencil} /></Link>
                                          <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                          {/* )} */}
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                          <Tab eventKey="Spreadsheets" title={<span>Spreadsheets </span>} className='moveto'>
                            <Table className='gallery_view'>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  <th>last modified</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files
                                  ?.filter(({ file_ext, file_type }) => {
                                    const ext = (file_ext || file_type || '').toLowerCase();
                                    return ['doc', 'docx', 'txt'].includes(ext);
                                  })
                                  .map((file, index) => {
                                    const fileName = file.file_name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();
                                    return (
                                      <tr>
                                        <td>
                                          <Form.Check // prettier-ignore
                                            type="checkbox"
                                            id="checkbox"
                                            checked={selectedRows.some(
                                              (row) => row.attachment_id === file.sn
                                            )}
                                            onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                          />
                                        </td>
                                        <td className="delimg">
                                          <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                        </td>
                                        <td>
                                          <span className="d-flex rafilename">
                                            <img src={Docmnt} className="fileimg" />
                                            <span>{file.file_name}</span>
                                          </span>
                                          <span>{file.file_size}</span> <span>{file.file_ext}</span>
                                        </td>
                                        <td><p>{file.category[0]}</p></td>
                                        <td><p>{file.modified_name}</p>
                                          <span>{file.modified_email}</span></td>
                                        <td>{file.last_modified}</td>
                                        <td className="delimg">
                                          {/* {file.is_comment !== 1 && file.is_editable === 1 && ( */}
                                          <Link to="#" onClick={() => handleOpenModal('S', file)} className="set_link"> <FontAwesomeIcon icon={faPencil} /></Link>
                                          <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                          {/* )} */}
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                          <Tab eventKey="pdfs" title={<span>PDF's </span>} className='moveto'>
                            <Table className='gallery_view'>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  <th>last modified</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files
                                  ?.filter(({ file_ext, file_type }) => {
                                    const ext = (file_ext || file_type || '').toLowerCase();
                                    return ['doc', 'docx', 'txt'].includes(ext);
                                  })
                                  .map((file, index) => {
                                    const fileName = file.file_name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();
                                    return (
                                      <tr>
                                        <td>
                                          <Form.Check // prettier-ignore
                                            type="checkbox"
                                            id="checkbox"
                                            checked={selectedRows.some(
                                              (row) => row.attachment_id === file.sn
                                            )}
                                            onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                          />
                                        </td>
                                        <td className="delimg">
                                          <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                        </td>
                                        <td>
                                          <span className="d-flex rafilename">
                                            <img src={Docmnt} className="fileimg" onClick={() => window.open(file.file_path, '_blank')} />
                                            <span>{file.file_name}</span>
                                          </span>
                                          <span>{file.file_size}</span> <span>{file.file_ext}</span>
                                        </td>
                                        <td><p>{file.category[0]}</p></td>
                                        <td><p>{file.modified_name}</p>
                                          <span>{file.modified_email}</span></td>
                                        <td>{file.last_modified}</td>
                                        <td className="delimg">
                                          {/* {file.is_comment !== 1 && file.is_editable === 1 && ( */}
                                          <Link to="#" onClick={() => handleOpenModal('S', file)} className="set_link"> <FontAwesomeIcon icon={faPencil} /></Link>
                                          <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                          {/* )} */}
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                          <Tab eventKey="Images" title={<span>Images </span>} className='moveto'>
                            <Table className='gallery_view'>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  <th>last modified</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files
                                  ?.filter(({ file_ext, file_type }) => {
                                    const ext = (file_ext || file_type || '').toLowerCase();
                                    return ['doc', 'docx', 'txt'].includes(ext);
                                  })
                                  .map((file, index) => {
                                    const fileName = file.file_name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();
                                    return (
                                      <tr>
                                        <td>
                                          <Form.Check // prettier-ignore
                                            type="checkbox"
                                            id="checkbox"
                                            checked={selectedRows.some(
                                              (row) => row.attachment_id === file.sn
                                            )}
                                            onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                          />
                                        </td>
                                        <td className="delimg">
                                          <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                        </td>
                                        <td>
                                          <img
                                            src={file.file_path}
                                            alt="Preview"
                                            style={{
                                              maxWidth: "22px",
                                              maxHeight: "22px",
                                              marginRight: "10px",
                                            }}
                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                            onClick={() => handleFileClick(file.file_path)}
                                          />
                                          <span>
                                            {/*file.file_name*/}
                                            {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 15)}... .${extension}`}
                                          </span>
                                        </td>
                                        <td><p>{file.category[0]}</p></td>
                                        <td><p>{file.modified_name}</p>
                                          <span>{file.modified_email}</span></td>
                                        <td>{file.last_modified}</td>
                                        <td className="delimg">
                                          {/* {file.is_comment !== 1 && file.is_editable === 1 && ( */}
                                          <Link to="#" onClick={() => handleOpenModal('S', file)} className="set_link"> <FontAwesomeIcon icon={faPencil} /></Link>
                                          <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                          {/* )} */}
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                        </Tabs>
                      </div>
                    </div>
                    :
                    <Table className="gallery_view">
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Uploaded by</th>
                          <th>last modified</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {files.map((file, index) => {
                          const fileName = file.file_name;
                          const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                          const extension = fileName?.split(".").pop();

                          return (
                            <tr key={`gv${index}`}>
                              <td>
                                {/* {console.log('attachment_no', file)} */}
                                <Form.Check // prettier-ignore
                                  type="checkbox"
                                  id="checkbox"
                                  checked={selectedRows.some(
                                    (row) => row.attachment_id === file.id
                                  )}
                                  onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                />
                              </td>
                              <td className="delimg">
                                <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                              </td>
                              <td>
                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                ) ? (
                                  <>
                                    <img
                                      src={file.file_path}
                                      alt="Preview"
                                      style={{
                                        maxWidth: "22px",
                                        maxHeight: "22px",
                                        marginRight: "10px",
                                      }}
                                      // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                      onClick={() => handleFileClick(file.file_path)}
                                    />
                                    <span>
                                      {/*file.file_name*/}
                                      {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <span className="d-flex rafilename">
                                      <img src={Docmnt} className="fileimg" />
                                      <span>{file.file_name}</span>
                                    </span>
                                  </>
                                )}
                                {/* <img src={Galpic} className='fileimg' /> {file.file_name} */}
                              </td>
                              <td>{file.file_type}</td>
                              <td>{file.file_size}</td>
                              <td>{file.upload_time}</td>
                              <td className="delimg">
                                {/* {file.is_comment !== 1 && file.is_editable === 1 && ( */}
                                <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                {/* )} */}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  }
                </div>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>

            <Modal show={typeModal} onHide={() => { setTypeModal(false); }} className='addfrom change_type' centered>
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body>
                <h3>{modalSection === 'S' ? 'Attachment Type' : 'Remove Attachment'}</h3>
                <p>{modalSection === 'S' ? 'Update this attachment type' : 'Are you sure you want delete this attachment?'}</p>
                {modalSection === 'S' &&
                  <Form.Group className="me-2">
                    {/* <Form.Select aria-label="Select" onChange={(e) => modalChange(e)} value={typeData || "0"}>
                      <option value="0">Select</option>
                      <option value="Invoice">Invoice</option>
                      <option value="Packinglist">Packinglist</option>
                      <option value="Emails">Emails</option>
                      <option value="HAWB">HAWB</option>
                      <option value="MAWB">MAWB</option>
                      <option value="Manifest">Manifest</option>
                      <option value="Customs">Customs</option>
                      <option value="Proposal">Proposal</option>
                      <option value="Other">Other</option>
                    </Form.Select>*/}
                    <Form.Select aria-label="Select" onChange={(e) => modalChange(e)} value={typeData || "0"}>
                      <option value="0">Select</option>
                      {(attachable_type === 'rfs_order'
                        ? ["CMR", "ADR", "AWB", "Manifest", "Loading List", "NCTS"]
                        : ["Invoice", "Packinglist", "Emails", "HAWB", "MAWB", "Manifest", "Customs", "Proposal", "Other"]
                      ).map((option) => (
                        <option key={option} value={option}>{option}</option>
                      ))}
                    </Form.Select>

                  </Form.Group>
                }
              </Modal.Body>
              <Modal.Footer>
                <div className='d-flex w-50 mx-auto are_bottom'>
                  {modalSection === 'S' ?
                    <Button variant="primary" onClick={modalUpdate}>
                      Update
                    </Button>
                    :
                    <>
                      <Button variant="secondary" onClick={() => setTypeModal(false)}>
                        No
                      </Button>
                      <Button variant="primary" onClick={modalUpdate}>
                        Yes
                      </Button>
                    </>
                  }
                </div>
              </Modal.Footer>
            </Modal>
            <Modal show={showModalUpload} onHide={closeModalUpload} className='addfrom change_type' centered>
              <Modal.Header closeButton>
                <div className='modal-title h4'>Upload Attachments</div>
                <p className='text-start'>Drag and drop or browse to upload your attachments.</p>
              </Modal.Header>
              <Modal.Body>
                <div className='type_work'>

                  <div className='ra_condition'>
                    <div
                      className='dropfile'
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                    >
                      <img src={Shipupload} alt="upload" />
                      <h3>Drag and drop files here</h3>
                      <p>Or</p>
                      <button className='btn btn-primary drpbtn' onClick={uploadTarget ? (e) => handleBrowseFiles(e, 'G', uploadTarget) : (e) => handleBrowseFiles(e, 'G')}>Browse Files</button>
                      <span>Maximum file size 25 MB</span>
                      <input
                        type="file"
                        ref={(el) => {
                          if (uploadTarget) {
                            fileInputRefc.current[uploadTarget] = el;
                          } else { fileInputRefs.current = el }
                        }}
                        style={{ display: 'none' }}
                        onChange={uploadTarget ? (e) => galleryFileChange(e, 'C', uploadTarget) : (e) => galleryFileChange(e, 'A')}
                        multiple
                      />
                    </div>
                    <div className='attach_shipment'>
                      {console.log('ufiles', ufiles)}
                      {ufiles.map((file, index) => (
                        <div key={index} className='uploadfil'>
                          {file?.base64?.includes('image') ? (
                            <>
                              <img
                                src={file.base64}
                                alt="Preview"
                                style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                              />
                              <span>{file.file_name}</span>
                            </>
                          ) : (
                            <>  <img src={Docmnt} className='fileimg' /> <span> {file.file_name}</span> </>
                          )}
                          <button className='dltbtn' type="button" onClick={() => handleUDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className='d-flex w-50 mx-auto are_bottom'>
                  <Button variant="primary" onClick={imageUpload}>
                    Upload
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </>
    );
  }
);

export default ImageUpload;
